import { get } from '../client'

export const getCompanyById = (id) => get(`companies/${id}`, true)

export const getAllCompanies = () => get(`companies`, true)
